import { Component, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
interface SideBarItem {
  title: string;
  price: string;
  phone: string;
  address: string;
}
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  public sidebarItems: SideBarItem[] = [];

  constructor(private menuController: MenuController) {}

  ngOnInit() {
      const userId = localStorage.getItem('userId');
      if (!userId) {
        localStorage.setItem(
          'userId',
          (Math.random() * 1000000000000000000).toFixed(0).toString()
        );
      }

    for (let index = 0; index < 30; index++) {
      this.sidebarItems.push({
        title: 'Title',
        price: 'some text',
        phone: 'some text',
        address: 'some text',
      });
    }
  }

  closeMenu() {
    this.menuController.close();
  }
}
